import { z } from "zod";

/**
 * FormData → JSON response operations
 * UploadFile, UploadFileAndAddDefault, ReplaceContentInWord, DocxToHtml, ParsePptx
 */

export const DocumentTemplateFormDataBodySchema = z.custom<FormData>();

// ============================================================================
// UPLOAD FILE
// ============================================================================

export const DocumentTemplateUploadFileResponseSchema = z.object({
  url: z.string()
});

// ============================================================================
// UPLOAD FILE AND ADD DEFAULT
// ============================================================================

export const DocumentTemplateUploadFileAndAddDefaultResponseSchema = z.object({
  url: z.string(),
  defaultFileUrl: z.string(),
  newFileUrl: z.string()
});

// ============================================================================
// REPLACE CONTENT IN WORD
// ============================================================================

export const DocumentTemplateReplaceContentResponseSchema = z.object({
  url: z.string()
});

// ============================================================================
// DOCX TO HTML
// ============================================================================

export const DocumentTemplateDocxToHtmlResponseSchema = z.object({
  html: z.string()
});

// ============================================================================
// PARSE PPTX
// ============================================================================

export const DocumentTemplateParsePptxResponseSchema = z.object({
  tags: z.array(z.unknown()),
  imagesUrls: z.array(z.string())
});
